import logError from '@alltrails/core/utils/logError';

export async function imageUrlToBase64(url) {
  try {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise<string | undefined>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result?.toString();
        resolve(base64data);
      };
      reader.onerror = reject;
    });
  } catch (error) {
    logError(new Error('Error converting image to base64', { cause: error }));
    return Promise.reject();
  }
}
